import React from "react";
import Hero from "../../components/Hero";
import HeroImage from "../../../assets/images/New8.jpg";
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";

const Blog5 = () => {
 const navigate = useNavigate();
 return (
   <div className="about-us-page">
     <Hero title="Blogs" backgroundImage={HeroImage} />
     <div className="primary-background-container-content">
       <div className="privacy-container">
         <h3>To Go Limited or Not to Go Limited; A Brief Guide for Doctors</h3>
         <p>
           As a financial planner who works closely with doctors and surgeons, I
           am often asked:
         </p>
         <p>
           “Should I set up a Limited Company for my private practice or
           consulting work?”
         </p>
         <p>
           It’s an excellent question, and one that doesn’t have a “one size
           fits all” answer. You may have heard rules of thumb like needing at
           least £24,000 in turnover to make it worthwhile. But the reality is
           far more nuanced. Sometimes earning an extra £10,000 to £12,000
           privately could actually push you over key thresholds, such as the
           £100,000 childcare benefit limit and leave you worse off overall.
         </p>
         <p>
           So, let’s look at what a Limited Company (LTD) is, how it works, and
           why it might (or might not) make sense for you.
         </p>
         <p>
           <strong>What Is a Limited Company?</strong>
         </p>
         <p>
           A Limited Company is a separate legal entity from you as an
           individual. It can own assets, enter contracts, and even be sued all
           in its own name. You can decide who owns the company and in what
           proportions.
         </p>
         <p>
           Unlike being self-employed, the money earned by the company is not
           automatically your personal income. It belongs to the company first,
           which means it’s taxed differently. The company pays Corporation Tax
           on profits, and you pay Dividend Tax or Income Tax only when you
           withdraw money.
         </p>
         <p>2025 Corporation Tax Rates</p>
         <p>• 19% on the first £50,000 of profit</p>
         <p>• rising to 25% on profits over £250,000 (via marginal relief)</p>
         <p>Dividend Tax Rates</p>
         <p>• Basic rate: 8.75% (£12570 to £50,270)</p>
         <p>• Higher rate: 33.75% (£50,271–£125,140)</p>
         <p>• Additional rate: 39.35% (over £125,140)</p>
         <p>• You also get a £500 annual dividend allowance.</p>
         <p>
           You can also pay yourself a salary from your LTD company via PAYE,
           which counts as a company expense and reduces the amount of profit
           subject to Corporation Tax. Salary payments will attract National
           Insurance for both employer and employee.
         </p>
         <p>
           <strong>Why Consider a Limited Company?</strong>
         </p>
         <p>
           Despite the added complexity, running your private practice,
           consulting work, or side gig through a Limited Company can have
           several strategic advantages especially when viewed through the lens
           of long-term financial planning.
         </p>
         <p>
           1. Timing Your Income
           <br /> Because profits belong to the company, and are only charged
           corporation tax once, you can choose when to withdraw income. This
           flexibility allows you to plan around tax thresholds such as the
           £100,000 childcare limit or defer withdrawals to future years when
           your income is lower (for example, after retirement or during a
           career break).
         </p>
         <p>
           2. Sharing Profits Tax-Efficiently
           <br />
           You can allocate shares in your company to your spouse, partner, or
           family members. Dividends are then split based on share ownership. If
           your partner pays tax at a lower rate, this can significantly reduce
           your household’s total tax bill. Children can be shareholders in some
           structures, though care is needed to avoid HMRC’s “settlement” rules.
         </p>
         <p>
           3. Employing Family Members
           <br />
           Your company can employ your spouse or children, as long as they’re
           genuinely working for the business, paid a fair wage which is not
           disproportionately high. This can spread income across your spouses
           potentially lower tax bands and teach financial skills to younger
           family members (while keeping HMRC happy).
         </p>
         <p>
           4. Building for Retirement
           <br />A Limited Company can make employer pension contributions on
           behalf of directors and employees up to the lower of their relevant
           earnings or the £60,000 yearly annual allowance. These contributions
           are classed as a qualifying business expense for the company, which
           can reduce your corporation tax. This is a powerful way to build
           pension wealth outside the NHS scheme and take advantage of some of
           the flexibilities that come with a private pension. If your spouse is
           a director or employee you can make company pension contributions
           which can allow you to bring balance to your incomes in retirement
           and potentially reduce the future tax bill.
         </p>
         <p>
           <strong>Advanced Planning Opportunities</strong>
         </p>
         <p>
           Once your company grows, there are additional strategies worth
           considering:
         </p>
         <p>
           5. Exiting Your Practice
           <br />
           When you eventually stop working privately, you may be able to wind
           up your company through a Members’ Voluntary Liquidation (MVL). As
           long as you have greater than £25,000 in retained profits these can
           then be withdrawn at Capital Gains Tax rates (14-24%) rather than
           dividend tax rates. If you qualify for Business Asset Disposal
           Relief, you may currently be eiligble for 14% tax rate (rising to 18%
           from April 2026) on the first £1 million of lifetime business
           disposal gains.
         </p>
         <p>
           6. Lending to Yourself
           <br />
           With sufficient retained profits, your company can lend you money for
           example, to buy a home. By charging interest (HMRC’s official rate is
           currently 2.5%), you can potentially borrow at lower rates than a
           bank, and you pay the interest back to your company rather than the
           bank.
         </p>
         <p>
           7. Planning for Your Family’s Future
           <br />A Family Investment Company (FIC) can allow you to transfer
           assets to children or future generations while retaining control. For
           example, the company could purchase an investment property with a
           loan from you for the deposit and a mortgage for the balance. The
           company would show as having zero net assets and you can then
           transfer the shares without facing a tax bill. They will then benefit
           from the capital growth and income generated from the investments,
           all within a structured, tax-efficient framework.
         </p>
         <p>
           <strong>Is a Limited Company Right for You?</strong>
         </p>
         <p>
           The right decision depends on your broader financial picture, your
           NHS income, private work, family circumstances, and long-term goals.
           A Limited Company can be an incredibly powerful tool for tax
           efficiency, income flexibility, and retirement planning, but it comes
           with administrative responsibilities and nuances that make
           professional advice essential.
         </p>
         <p>
           <strong>Final Thoughts</strong>
         </p>
         <p>
           Setting up a Limited Company isn’t just about saving tax it’s about
           taking control of your income, retirement, and family wealth in a way
           that supports your career as a medic both now and in the future.
         </p>
         <p>
           If you’re considering starting a Limited Company or wondering whether
           it suits your current situation, I’d be happy to help you explore
           your options.
         </p>
         <p>Let’s make sure your business structure works for you.</p>
         <p>
           Book a consultation today or drop me an email, to discuss how a
           Limited Company could fit into your personal financial plan.
         </p>
       </div>
       <Button
         text="CONTACT US"
         variant="primary"
         onClick={() => navigate("/contact")}
       />
     </div>
   </div>
 );
};

export default Blog5;
